<template>
        <div class="container login-wrap col-md-4 mx-auto border rounded px-2 py-2">
            <div class="title-wrap border-bottom mb-3">
                <h1>{{$ml.with('VueJS').get('Authentication')}}</h1>
            </div>
                <div class="w-100 form-wrap mb-2">
                    <b-form>
                        <b-form-group id="input-username" :label="`${$ml.with('VueJS').get('Email')}:`" label-for="username" class="text-left">
                            <b-form-input
                                    id="username"
                                    v-model="form.username"
                                    placeholder=""
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group id="input-password" :label="`${$ml.with('VueJS').get('Password')}:`" label-for="password" class="text-left">
                            <b-form-input
                                    id="password"
                                    v-model="form.password"
                                    type="password"
                                    placeholder=""
                            ></b-form-input>
                        </b-form-group>
                    </b-form>

                    <b-button type="submit" variant="primary" class="w-100" @click="login()">{{$ml.with('VueJS').get('Login')}}</b-button>

                </div>

            <div class="w-100">
                <router-link to="/recover-password">
                    {{$ml.with('VueJS').get('RecoverPassword')}}
                </router-link>
            </div>
        </div>
</template>

<style lang="scss">
    .login-wrap {
        background-color: #f2f2f2;
    }
    .title-wrap h1 {
        line-height: 85px;
    }
</style>

<script>
  import axios from 'axios';
  import { apiRoot } from "@/helpers/variables";
  import mixinUtils from "@/components/mixinUtils";
  export default {
    name: 'login',
    mixins: [mixinUtils],
    components: {
    },
    data: () => ({
        form: {
          username: null,
          password: null,
        }
    }),
    methods: {
      login: function () {
        const context = this
        axios.post(apiRoot + 'auth/gen-jwt-token',
          {
            username: context.form.username,
            password: context.form.password,
          },
          {
            useCredentails: true,
            headers: {
              'Content-Type': 'application/json'
            }
          }
        ).then(response => {
          this.$store.commit('setUser', response.data);

          this.$bvToast.toast(`Вы успешно авторизовались как ${response.data.username}`, {
            title: 'Авторизация',
            autoHideDelay: 5000,
            variant: 'success',
            appendToast: false,
            toaster: 'b-toaster-bottom-right',
          })

          this.$router.push({path: '/profile'})
        }).catch(error => {
          switch (error.response.status) {
            case 401:
              this.$bvToast.toast(`Неверный логин или пароль`, {
                title: 'Ошибка',
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
              break;
          default:
            this.$bvToast.toast(`${error.message}`, {
              title: 'Ошибка',
              autoHideDelay: 5000,
              variant: 'danger',
              appendToast: false,
              toaster: 'b-toaster-bottom-right',
            })
            break;
          }

        });
      }
    },
    mounted() {
      if (this.$store.state.isAuthenticated()) {
        this.$router.push({path: '/profile'})
      }
    }
  }
</script>